import "core-js/modules/es.array.join.js";
import { capitalize } from "./capitalize";
export var snakeCaseCapitalizeFirst = function snakeCaseCapitalizeFirst(str) {
  return str && typeof str === 'string' ? capitalize(str).split('_').join(' ') : str;
};